"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const extendZodWithDummyOpenApi = (zod) => {
    if (typeof zod.ZodType.prototype.openapi !== 'undefined') {
        return;
    }
    zod.ZodType.prototype.openapi = function () {
        return this;
    };
};
extendZodWithDummyOpenApi(zod_1.z);
